// Status badges colors
export const statusColors = {
  rascunho: 'bg-gray-100 text-gray-800',
  enviado: 'bg-blue-100 text-blue-800',
  aprovado: 'bg-green-100 text-green-800',
  rejeitado: 'bg-red-100 text-red-800',
  convertido: 'bg-purple-100 text-purple-800',
  pendente: 'bg-yellow-100 text-yellow-800',
  faturado: 'bg-emerald-100 text-emerald-800',
  pago: 'bg-green-100 text-green-800',
  cancelado: 'bg-red-100 text-red-800',
  aguardando_assinatura: 'bg-amber-100 text-amber-800',
  ativo: 'bg-green-100 text-green-800',
  inativo: 'bg-red-100 text-red-800',
  excluido: 'bg-slate-100 text-slate-500',
  suspenso: 'bg-orange-100 text-orange-800',
  encerrado: 'bg-gray-100 text-gray-800',
};

export const statusLabels = {
  rascunho: 'Rascunho',
  enviado: 'Enviado',
  aprovado: 'Aprovado',
  rejeitado: 'Rejeitado',
  convertido: 'Convertido',
  pendente: 'Pendente',
  faturado: 'Faturado',
  pago: 'Pago',
  cancelado: 'Cancelado',
  aguardando_assinatura: 'Aguard. Assinatura',
  ativo: 'Ativo',
  inativo: 'Inativo',
  excluido: 'Excluído',
  suspenso: 'Suspenso',
  encerrado: 'Encerrado',
};

export const categoriaLabels = {
  servico: 'Serviço',
  material: 'Material',
  aluguel: 'Aluguel',
  salario: 'Salário',
  imposto: 'Imposto',
  manutencao: 'Manutenção',
  outros: 'Outros'
};

export const API_URL = process.env.REACT_APP_BACKEND_URL;
